exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".hidden-border{border:0!important;background:#fff!important}", "", {"version":3,"sources":["D:/app/gocode/src/gitlab.com/satit13/VillageService/ui/src/components/cate_view.vue"],"names":[],"mappings":"AACA,eACE,mBAAsB,AACtB,yBAA2B,CAC5B","file":"cate_view.vue","sourcesContent":["\n.hidden-border {\n  border: 0px!important;\n  background: #fff!important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-014f02d8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cate_view.vue
// module id = 250
// module chunks = 0 3